(ns app.front.view.wizard.property-selector
  (:require [app.domain.property.model :as property-model]
            [core.util.schemas :as schemas]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]
            [schema-tools.core :as st]
            [schema.core :as s]))


(s/defschema StrictLocationWizardParams
  (st/merge {:address s/Any
             :x       s/Num
             :y       s/Num}
            (st/optional-keys {:gis-id                  s/Any
                               :gis-layer               (s/cond-pre s/Keyword s/Str)
                               :property/integration-id schemas/NonBlankString
                               :municipality            schemas/NonBlankString
                               :subdivision             (s/cond-pre s/Keyword s/Str)
                               :property/id             schemas/NonBlankString
                               :property/secondary-id   s/Str
                               :property/legal          s/Str
                               :property/type-code      s/Str
                               :property/zoning         s/Str
                               :property/ward           s/Str
                               :property/description    s/Str
                               :location/description    s/Str
                               :geometry                s/Any
                               :property/from-st        s/Str
                               :property/to-st          s/Str
                               :property/type           (s/enum :property.type/property :property.type/road)})))


(def check-strict-location-wizard-params (s/checker StrictLocationWizardParams))




(s/defschema LocationWizardParams
  (st/optional-keys StrictLocationWizardParams [:x :y]))


(def location-keys-without-project (keys (st/required-keys LocationWizardParams)))


(rf/reg-event-fx ::fetch-property-attributes
  (fn [_ [_ group-id {:keys [geometry-point]}]]
    {:comm/command {:command    :property/attribute-search
                    :data       {:group/id    group-id
                                 :coordinates geometry-point}
                    :on-success [::fetch-property-attributes.success]}}))


(defn owner-cache-key
  "Key for a GIS record's owners. A property id can belong to several records,
   so the integration-id is part of it."
  [property]
  ((juxt :property/id :property/integration-id) property))

(rf/reg-event-fx ::fetch-property-owners
  (fn [_ [_ group-id {:keys [property geometry-point]}]]
    {:comm/command {:command    :property/owner-search
                    :data       (p/assoc-if {:group/id    group-id
                                             :coordinates geometry-point}
                                            :property/integration-id (:property/integration-id property)
                                            :property/id             (:property/id property))
                    :on-success [::fetch-property-owners.success (owner-cache-key property)]}}))

(rf/reg-event-db ::fetch-property-owners.success
  (fn [db [_ owner-key _ owners]]
    (assoc-in db [::property-owners owner-key] owners)))


(rf/reg-sub ::property-owners
  (fn [db [_ local-id]]
    (get-in db [::property-owners local-id])))


(rf/reg-event-db ::fetch-property-attributes.success
  (fn [db [_ _ attributes]]
    (assoc db ::property-attributes attributes)))

(rf/reg-event-db ::clear-property-metadata
  (fn [db _]
    (-> db
        (dissoc ::property-attributes)
        (dissoc ::property-owners))))


(rf/reg-sub ::property-attributes
  (fn [db _]
    (-> db ::property-attributes)))

(defn point-search-command [coordinates {:keys [domain-group-id selected-municipality layer-ids]} on-success on-failure]
  {:command        :address/point-search
   :data           (cond-> {:coordinates     coordinates
                            :domain-group-id domain-group-id
                            :property-types  [:property.type/road :property.type/property]
                            :sourceCRS       "3857"}
                     selected-municipality
                     (assoc :municipality selected-municipality)

                     layer-ids
                     (assoc :layer-ids layer-ids))
   :on-success     on-success
   :on-not-found   (conj on-failure coordinates false)
   :on-bad-request (conj on-failure coordinates true)
   :on-bad-gateway (conj on-failure coordinates true)})


; feature is of type app.address.api/GisData
(s/defn make-location :- LocationWizardParams
  "Return feature in QueryParams friendly format"
  [municipality-id subdivision {[x y] :geometry-point :keys [address property gis-id gis-layer geometry]}]
  (p/assoc-if
    (merge {:address (or address
                         {})
            :x       x
            :y       y}
           (select-keys property property-model/property-creation-keys))
    :gis-id gis-id
    :gis-layer gis-layer
    :municipality municipality-id
    :subdivision subdivision
    :geometry geometry))
